import { MarkerSelectValue } from './types';
const markerColors = {
    [MarkerSelectValue.NEUTRAL]: {
        disabled: ({ theme }) => theme.colors.grey10_1,
        background: ({ theme }) => theme.colors.grey100_1,
    },
    [MarkerSelectValue.INFORMATIVE]: {
        disabled: ({ theme }) => theme.colors.link10,
        background: ({ theme }) => theme.colors.link100,
    },
    [MarkerSelectValue.POSITIVE]: {
        disabled: ({ theme }) => theme.colors.positive10,
        background: ({ theme }) => theme.colors.positive100,
    },
    [MarkerSelectValue.WARNING]: {
        disabled: ({ theme }) => theme.colors.warning10,
        background: ({ theme }) => theme.colors.warning100,
    },
    [MarkerSelectValue.NEGATIVE]: {
        disabled: ({ theme }) => theme.colors.critical10,
        background: ({ theme }) => theme.colors.critical100,
    },
};
export const getItemDimensions = (isMarker) => ({
    width: isMarker ? '14px' : '28px',
    height: isMarker ? '14px' : '28px',
    innerSize: isMarker ? '14px' : '18px',
    hoverSize: '22px',
});
export const getBackgroundColor = ({ $marker, theme, $isDisabled, $isSelected }) => $isDisabled && !$isSelected ? markerColors[$marker].disabled({ theme }) : markerColors[$marker].background({ theme });
export const isMarkerSelectValue = (value) => Object.values(MarkerSelectValue).includes(value);
